import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
class GetNewsSearchUrlUseCase extends UseCase {
  /**
   * @constructor
   */
  constructor({newsSearchUrlValueObjectFactory}) {
    super()
    this._newsSearchUrlValueObjectFactory = newsSearchUrlValueObjectFactory
  }

  @tracer({metric: 'GetNewsSearchUrlUseCase#execute'})
  execute({tag, category, searchTerm, section, page}) {
    return Promise.resolve(
      this._newsSearchUrlValueObjectFactory({
        tag,
        category,
        searchTerm,
        section,
        page
      }).toJSON()
    )
  }
}

export default GetNewsSearchUrlUseCase
